/**
 * Badge-specific utilities for matter title badges.
 */

import { MatterStatus } from '@/services/types/client-intake-types';

export const BADGE_BASE_CLASSES =
  'text-xs px-1.5 py-0.5 rounded transition-colors bg-transparent hover:bg-zinc-50 border border-transparent hover:border-zinc-200';

/**
 * Get display label for status.
 * MatterStatus values are already in display format (e.g., "Initial Review").
 */
export const getStatusLabel = (status: MatterStatus): string => status;
